module.exports = __webpack_public_path__ + "img/1511680766.eaf09172.jpg";